import React from 'react';
import './Static.css';

import { Link } from 'react-router-dom';

import svgLocation from '../Img/icon/location.svg';
import svgMail from '../Img/icon/mail.svg';
import svgViber from '../Img/icon/viber.svg';
import svgCopyright from '../Img/icon/copyright.svg';

import Nav from './Nav';

const Static = (props) => {
  return (
    <React.Fragment>
      <header>
        <div className="heder-conteiner">
          <Link to='/'><h1>legatus</h1></Link>
          <h2>Працюємо по всій Україні</h2>
          <h2>Юридичний та бухгалтерський  супровід бізнесу</h2>
        </div>
      </header>
  
      <main>
        <div className="main-conteiner">
<Nav />
{props.children}
        </div>
      </main>
      
      <footer>
        <div className="footer-conteiner">
          <section className="s-footer">
            {/* <img src={svgLocation} alt=""/> Київ, проспект Берестейський, 89А <br/> */}
          
            <div className="telefon"> 
								<a href="tel:+380502244324">(050) 224-43-24 </a> <br/>
                                  <a href="tel:+380672244324">(067) 224-43-24</a> <br/>
                                  <a href="tel:+380635312136">(063) 531-21-36</a><br/>
                                  <img src={  svgMail  } alt=""/> <a href="mailto:consultingur@gmail.com">consultingur@gmail.com</a> 
								  
        </div> <br/>
            <a className="copyright" href="mailto:infSpell@gmail.com" title=" infSpell@gmail.com">
              <img src={svgCopyright} alt=""/>_inf 
            </a>
          </section>
        </div>
      </footer>
    </React.Fragment>
  );
}

export default Static;


// WEBPACK FOOTER //
// ./src/Components/Static.jsx